import React from 'react'
import { InputText } from 'primereact/inputtext'

const InputTextEditor = ({ options, validationErrors }) => {
    const rowIndex = options.rowIndex
    return (
        <InputText
            type="text"
            value={options.value}
            onChange={(e) => options.editorCallback(e.target.value)}
            className={validationErrors[rowIndex] && validationErrors[rowIndex][options.field] ? 'p-invalid' : ''}/>
    )
}

export default InputTextEditor
